import { startSapSync } from '@/Services/sapAdapterService';

/**
 * Vuex module: integrations/sapSync
 * - Triggers sync operations against the SAP adapter using the stored API key.
 */
const state = () => ({
  syncing: false,
  lastSummaries: {
    items: null,
    debtors: null,
    stockQty: null,
  },
  error: null,
});

const mutations = {
  setSyncing(s, v) { s.syncing = !!v; },
  setSummary(s, { resource, summary }) { s.lastSummaries[resource] = summary || null; },
  setError(s, e) { s.error = e || null; },
};

const actions = {
  /**
   * @param context
   * @param {Object} payload
   */
  async syncItems({ commit, rootState }, payload = { mode: 'incremental', pageSize: 100000 }) {
    try {
      commit('setSyncing', true);
      const apiKey = rootState.integrations?.sap?.sapApiKey;
      if (!apiKey) throw new Error('SAP adapter not integrated for this store.');
      const summary = await startSapSync('/sync/items', apiKey, payload);
      commit('setSummary', { resource: 'items', summary });
      return summary;
    } catch (e) {
      commit('setError', e);
      throw e;
    } finally {
      commit('setSyncing', false);
    }
  },
  async syncDebtors({ commit, rootState }, payload = { mode: 'incremental', pageSize: 100000 }) {
    try {
      commit('setSyncing', true);
      const apiKey = rootState.integrations?.sap?.sapApiKey;
      if (!apiKey) throw new Error('SAP adapter not integrated for this store.');
      const summary = await startSapSync('/sync/debtors', apiKey, payload);
      commit('setSummary', { resource: 'debtors', summary });
      return summary;
    } catch (e) {
      commit('setError', e);
      throw e;
    } finally {
      commit('setSyncing', false);
    }
  },
  async syncStockQty({ commit, rootState }, payload = { mode: 'full', pageSize: 100000 }) {
    try {
      commit('setSyncing', true);
      const apiKey = rootState.integrations?.sap?.sapApiKey;
      if (!apiKey) throw new Error('SAP adapter not integrated for this store.');
      const summary = await startSapSync('/sync/stock-qty', apiKey, payload);
      commit('setSummary', { resource: 'stockQty', summary });
      return summary;
    } catch (e) {
      commit('setError', e);
      throw e;
    } finally {
      commit('setSyncing', false);
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};